import { Provider } from '@angular/core';
import { LinkedTasksHttpService } from './abstract';
import { LinkedTasksHttpServiceImpl } from './subtasks-http-service';

export const LinkedTasksHttpProvider: Provider = {
	provide: LinkedTasksHttpService,
	useClass: LinkedTasksHttpServiceImpl,
};
